<template>
  <div class="collectionNavTop"
    :style="navTop.style">
    <div v-if="!isMainPage" class="left">
      <button type="button" class="btnBack" @click="goBack">
        <img :src="btnBack.src" :style="btnBack.style" alt="" />
      </button>
      <div v-if="breadCrumb && breadCrumb.length" class="breadCrumb">
        <router-link v-for="path in breadCrumb"
          :key="path.categoryId"
          :to="routeFromBreadCrumb(path.routeName, path.categoryId)"
          class="path">
          {{ path.categoryLabel[lang] }}
        </router-link>
      </div>
    </div>
    <img :src="navTop.logo" class="collectionLogo test12345" :style="{height: `${navTop.logoHeight}px`}" @click="goMain" />
    <div class="right">
      <button type="button" class="btnMenu" @click.stop="setMegaMenu">
        <img :src="btnMenu.src" :style="btnMenu.style" alt="" />
      </button>
      <router-link v-if="useCollectionPage && myCollectionCategoryId"
        type="button"
        class="btnMyCollection"
        :to="{name: 'myCollection', params: { ln: $route.params.ln, pageId: pageId }}">
        <img :src="btnMyCollection.src" :style="btnMyCollection.style" alt="" />
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CollectionNavTop',
  props: [
    'locale',
    'lang',
    'pageId',
    'categoryId',
    'isMainPage',
    'setting'
  ],
  computed: {
    useCollectionPage () {
      return this.$store.getters['collection/useCollectionPage']
    },
    pageFrame () {
      return this.$store.getters['collection/getPageFrame']
    },
    navTop () {
      const setting = this.setting
      const navTop = setting && setting.navTop
      const category = setting && setting.category
      const getFrame = this.$store.getters['collection/getPageFrame']
      const frame = getFrame === '0' ? '24' : getFrame
      return {
        logo: navTop && navTop.logo,
        logoHeight: navTop && navTop.logoHeight,
        style: {
          backgroundColor: navTop && navTop.backgroundColor,
          height: `${navTop && navTop.height}px`,
          ...frame && {
            paddingLeft: `${frame}px`,
            paddingRight: `${frame}px`
          }
        }
      }
    },
    btnBack () {
      const setting = this.setting
      const icons = setting && setting.icons && setting.icons.back
      return {
        src: icons && icons.image,
        style: {
          width: `${icons && icons.size}px`
        }
      }
    },
    btnMenu () {
      const setting = this.setting
      const icons = setting && setting.icons && setting.icons.menu
      return {
        src: icons && icons.image,
        style: {
          width: `${icons && icons.size}px`
        }
      }
    },
    btnMyCollection () {
      const setting = this.setting
      const icons = setting && setting.icons && setting.icons.myCollection
      const isMyCollection = this.$route.name === 'myCollection'
      return {
        src: icons && (isMyCollection ? icons.active : icons.default),
        style: {
          width: `${icons && icons.size}px`
        }
      }
    },
    breadCrumb () {
      const getCategoryListAll = this.$store.getters['collection/getCategoryListAll']
      function getBreadcrumbById (categoryId, categoryList) {
        const path = []
        function findPath(categories, targetId, currentPath) {
          for (const category of categories) {
            const newPath = [...currentPath, {
              categoryId: category.categoryId,
              categoryLabel: category.categoryLabel,
              routeName: category.useMain ? 'collectionCategoryMain' : 'collectionPage'
            }]

            if (category.categoryId === targetId) {
              path.push(...newPath)
              return true
            }

            if (category.subCategory && category.subCategory.length) {
              const found = findPath(category.subCategory, targetId, newPath)
              if (found) return true
            }
          }
          return false
        }

        findPath(categoryList, categoryId, [])
        return path
      }
      return getCategoryListAll && getBreadcrumbById(this.categoryId, getCategoryListAll)
    },
    pageSetting () {
      return this.$store.getters['collection/getCollectionMainPage']
    },
    getMyCollectionSetting () {
      return this.$store.getters['collection/getMyCollectionSetting']
    },
    myCollectionCategoryId () {
      const category = this.getMyCollectionSetting && this.getMyCollectionSetting.category
      function getFirstCategoryId (arr) {
        if (!arr || arr.length === 0) return null
        const first = arr[0]
        if (first.subCategory && first.subCategory && first.subCategory.length > 0) {
          return first.subCategory[0].categoryId
        }
        return first.categoryId
      }
      return getFirstCategoryId(category)
    }
  },
  methods: {
    goMain () {
      const routerName = this.pageSetting.cover
        ? 'collectionCover'
        : this.pageSetting.intro
          ? 'collectionIntro'
          : 'collectionMain'
      this.$router.push({
        name: 'collectionMain',
        params: {
          ...this.$route.params,
          categoryId: ''
        }
      })
    },
    routeFromBreadCrumb (routeName, categoryId) {
      return {
        name: routeName,
        params: {
          ...this.$route.params,
          categoryId: categoryId
        }
      }
    },
    goBack () {
      // const categoryId = this.categoryId
      // const parentCategoryId = this.$store.getters['collection/getParentCategoryId'](categoryId)
      // if (this.$route.name === 'myCollection') {
      //   this.$router.go(-1)
      // } else {
      //   this.$router.push({
      //     ...parentCategoryId === 'main' && {
      //       name: 'collectionMain',
      //       params: {
      //         ...this.$route.params
      //       }
      //     },
      //     ...parentCategoryId !== 'main' && {
      //       name: 'collectionPage',
      //       params: {
      //         ...this.$route.params,
      //         categoryId: parentCategoryId
      //       }
      //     }
      //   })
      // }
      this.$router.go(-1)
    },
    setMegaMenu () {
      this.$store.commit('collection/setMegaMenu', true)
    }
  }
}
</script>